import { useFormContext } from 'react-hook-form'
import { FormCreditData } from '../../useCreditController'

export const useCreditBalanceFormController = () => {
  const methods = useFormContext<FormCreditData>()

  return {
    methods,
  }
}
